import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function NavMenu({ selectedMenu, onNavigationClick, navigationItems, onHamburgerClick }) {
    const navigate = useNavigate();

    function handleNavigationClick(event) {
        var name = event.currentTarget.getAttribute("name");
        onNavigationClick(name);
        navigate(`/${name}`);
    }

    let navItems = navigationItems && navigationItems.map(navItem => {
        let selectedClassName = navItem.path === selectedMenu ? "selected" : "";
        return (<li key={navItem.path} name={navItem.path} className={selectedClassName} onClick={handleNavigationClick}>
            <i className={navItem.iconClass} />
            <span className="navMenuItemDesc">{navItem.name}</span>
        </li>);
    });

    var hamburgerItem = onHamburgerClick && (<li className="hamburger" onClick={onHamburgerClick}>
        <i className="dhicon-menu-hamburger" />
    </li>);

    let navList = (<ul>{hamburgerItem}{navItems}</ul>);

    return (<div className="navigation-menu">{navList}</div>);
}